import axiosInstance from "@/api/axiosInstance";
import { FetchProductDetailsResponse } from "./types";

export const fetchProductDetails = async (
  uuid: string,
): Promise<FetchProductDetailsResponse> => {
  const response = await axiosInstance.get<FetchProductDetailsResponse>(
    `/api/private/product-details/${uuid}`,
  );
  return response.data;
};
